import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";
import * as firebase from "firebase/app";

import { IStaffType } from "./../../interfaces/staff";
import { Observable } from 'rxjs';

@Injectable()
export class StaffProvider {

  private staffCollection: AngularFirestoreCollection<IStaffType>;

  constructor(private db: AngularFirestore) {}

  getStaffTypes(): Observable<IStaffType[]> {
    this.staffCollection = this.db.collection<IStaffType>('staffTypes', ref => ref.orderBy('title'));
    return this.staffCollection.valueChanges();
  }

  getStaffTypeById(id: string): Observable<IStaffType> {
    return this.db.collection('staffTypes').doc<IStaffType>(id).valueChanges();
  }

}



// WEBPACK FOOTER //
// ./src/providers/staff/staff.ts